import { render, staticRenderFns } from "./VendorAccount.vue?vue&type=template&id=fc9fda0c&scoped=true&"
import script from "./VendorAccount.vue?vue&type=script&lang=js&"
export * from "./VendorAccount.vue?vue&type=script&lang=js&"
import style0 from "./VendorAccount.vue?vue&type=style&index=0&id=fc9fda0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9fda0c",
  null
  
)

export default component.exports